module.exports = __webpack_public_path__ + "img/commonEmpty.5b864b5d.png";